
// export const baseUrl = "https://api.astroafrica.site/v1";
export const baseUrl = "https://astroafrica-backend.onrender.com/v1";
export const REACT_APP_RECAPTCHA_SITE_KEY = "6Lf_NNwqAAAAAELBk1sG5qpz09Hg2eiNKfnOg6uF";
